import MediaIcon from './MediaIcon'

export default MediaIcon
